export	function sumit(_this, cookieUtil){
	if(_this.isSumit){
		return;
	}
	_this.isSumit = true;
	_this.loading = weui.loading('正在提交');
	_this.$axios.post(_this.stuApiUrl + "/student/register", 
	_this.$qs.stringify({
		openId:_this.openId,
		pic:_this.headImgUrl,
		unionId:_this.unionId,
		staffNumber:_this.staffNumber,
		name:_this.name,
		phone:_this.phone,
		schoolId:_this.schoolId,
		code:_this.code,
	})).then(function (response) {
		if(!response.data.success){
			_this.loading.hide();
			_this.isSumit = false;
			return weui.alert(response.data.info);
		}
		_this.loading.hide();
		weui.toast('提交成功');
		_this.delCookie('SC_WX_USER_COOKIE');
		window.sessionStorage.setItem('SC_USER',JSON.stringify(response.data.user));
		//判断跳转页面
		var path = '/student/user/center';
		if(_this.sign != null && _this.sign.schoolId && _this.sign.coursewareId){
			path = '/student/user/sign/pc/' + _this.sign.schoolId + "/" + _this.sign.coursewareId;
			if(_this.sign.mac){
				path = '/student/user/sign/app/' + _this.sign.schoolId + "/"+_this.sign.mac+"/" + _this.sign.coursewareId;
			}
		}
		if(_this.join != null && _this.join.schoolId){
			path = '/student/user/join/class/' + _this.join.schoolId + "/" + _this.join.classId;
			if(_this.join.mac){
				path = '/student/user/join/group/' + _this.join.schoolId + "/"+_this.join.mac+"/" + _this.join.coursewareId;
			}
		}
		
		
		_this.delCookie('SC_SIGN');
		_this.delCookie('SC_JOIN');
		


		weui.toast('注册成功');
		_this.$axios.post(_this.apiUrl + "/auth/login", _this.$qs.stringify({userId: response.data.user.id}))
		.then(function (response) {
			if(!response.data.success){//登录失败
				if(!response.data.errorcode){//用户不存在或者已删除
					cookieUtil.delCookie("SC_COOKIE_USER_ID");
					return _this.$router.replace('/auth');
				}
				return;
			}
			
			var url = cookieUtil.getCookie("SC_COOKIE_URL");
			url = decodeURIComponent(url);
			
			_this.user = response.data.user;
			window.sessionStorage.setItem("SC_USER",JSON.stringify(_this.user));
			cookieUtil.setCookieEXP('SC_COOKIE_USER_ID', _this.user.id, 3600);
			
			if(url && url.indexOf('scan') > -1){
				path = url;
			}
			_this.$router.replace(path);
		}).catch(function (error) {
			console.log(error);
		});


	}).catch(function (error) {
		_this.isSumit = false;
		_this.loading.hide();
		console.log(error);
	});
}

export function getVCode(_this, successCallback){
	_this.$axios.post(_this.stuApiUrl + "/student/is-exist", _this.$qs.stringify({phone:_this.phone, isUpdate : 0})).then(function (response) {
		if(!response.data.success){
			return weui.alert(response.data.info);
		}
		_this.$axios.post(_this.stuApiUrl + "/student/stu-wechat-message", _this.$qs.stringify({phone:_this.phone})).then(function (response) {
			if(!response.data.success){
				return weui.alert("发送验证码, 失败");
			}
      weui.toast('验证码发送成功');
      successCallback && successCallback()
		}).catch(function (error) {
			console.log(error);
		});
	}).catch(function (error) {
		console.log(error);
	});
}


//////////////////
// WEBPACK FOOTER
// ./static/js/user/reg.js
// module id = null
// module chunks = 